import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render({ item }) {
        return (
            <catalog-input-item key={item.key}>
                <label>
                    <input
                        type='checkbox'
                        name={item.key}
                        value={item.value}
                        checked={item.checked}
                        onChange={() => this.handleChange(item)}
                    />
                    {item.name}
                </label>
            </catalog-input-item>
        );
    }

    handleChange = (item) => {
        item.checked = !item.checked;
        this.props.callback();
        this.props.setFilter();
    }
}

const mapDispatchToProps = (dispatch) => ({
    setFilter: () => dispatch({ type: 'catalog:set-filter' }),
});

export default connect(null, mapDispatchToProps)(Component);
